import { BlogWebsite, FAQWebsite } from "./system";

import CommonNavLabels from "./../const/common.json";

export const HeaderMiniBreakPoint = 100;

export const HeaderMenu = {
    "_default": [
        {
            path: "AboutPage",
            labelName: "NavLabelAbout",
        },
        {
            path: "Products",
            labelName: "NavLabelProducts",
        },
        {
            path: "PartnersPage",
            labelName: "NavLabelPartners",
        },
        {
            path: BlogWebsite,
            type: "external",
            labelName: "NavLabelBlog",
        },
        {
            path: FAQWebsite,
            type: "external",
            labelName: "NavLabelFAQ",
        },
    ],
    "motorcycles": [
        {
            path: "MotorcyclesProducts",
            labelName: "NavLabelMotorcycleProducts",
        },
        {
            path: FAQWebsite,
            type: "external",
            labelName: "NavLabelFAQ",
        },
    ],
};

export const HeaderVerticalMenu = {
    "_default": [
        {
            path: "Products",
            labelName: CommonNavLabels["NavLabelProducts"],
        },
        {
            path: "PartnersPage",
            labelName: CommonNavLabels["NavLabelPartners"],
        },
        {
            path: "AboutPage",
            labelName: CommonNavLabels["NavLabelAbout"],
        },
        {
            path: FAQWebsite,
            type: "external",
            labelName: CommonNavLabels["NavLabelFAQ"],
        },
        {
            path: "Testimonials",
            labelName: CommonNavLabels["NavLabelTestimonials"],
        },
        {
            path: "NewsPage",
            labelName: CommonNavLabels["NavLabelNews"],
        },
        {
            path: "TermsPage",
            labelName: CommonNavLabels["NavLabelTerms"],
        },
        {
            path: "PrivacyPage",
            labelName: CommonNavLabels["NavLabelPrivacy"],
        },
    ],
    "motorcycles": [
        {
            path: "MotorcyclesProducts",
            labelName: "Motorcycle Loans",
        },
        {
            path: "Products",
            labelName: "Business Loans",
        },
        {
            path: "AboutPage",
            labelName: "About SeekCap",
        },
    ],
};
